import React from 'react';
import './index.scss';

const BackgroundShine = () => {
  return (
    <div className="backgroundShine" />
  );
};

export default BackgroundShine;
